<template>
  <div class="tags-container px-5 pb-2">
    <v-checkbox v-for="(tag, idx) in options" :key="idx" v-model="filterTags" :label="tag.name" :value="tag.id" color="orange50" hide-details />
  </div>
</template>

<script>
let filterDebounce = null

export default {
  name: 'CheckBoxFilter',
  props: {
    value: { type: Array, default: () => [] },
    isClear: { type: Boolean, default: false },
    keyValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
  },
  emits: ['returnFilter', 'updateClearBtn'],
  data() {
    return {
      filterLoading: false,
      filterTags: this.value || [],
    }
  },
  computed: {
    showClearBtn() {
      return this.filterTags.length > 0
    },
  },
  watch: {
    isClear(newVal) {
      if (newVal) {
        this.clearData()
        this.$emit('updateClearBtn', false)
      }
    },
    filterTags() {
      clearTimeout(filterDebounce)
      filterDebounce = setTimeout(() => {
        this.estimateTotalCount()
      }, 500)
    },
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    checkActivated() {
      return this.filterTags.length > 0
    },
    clearData() {
      this.filterTags = []
    },
    estimateTotalCount() {
      this.$emit('updateClearBtn', this.checkActivated())
      this.$emit('returnFilter', this.filterTags)
    },
  },
}
</script>

<style lang="scss" scoped>
.tags-container {
  max-height: 304px;
  overflow-y: auto;
}
</style>

<style lang="scss">
.v-input--selection-controls {
  .v-input__slot {
    & > .v-label {
      font-size: 15px;
      color: $black50;
    }
  }
}
</style>
